import { autorun } from "mobx";
import { useEffect, useState } from "react";
import type SingleSelectFilter from "@tajawal/web-flights-sdk/lib/stores/filter/base/single-select-filter.store";

export function useStateOfSingleSelectFilter(store: SingleSelectFilter) {
  const getProps = (store: SingleSelectFilter) => ({
    id: store?.id,
    state: store?.state,
    isDirty: store?.isDirty,
    reset: store?.reset,
    set: store?.set,
    selectedItem: store?.selectedItem,
  });

  const [state, setState] = useState(getProps(store));

  useEffect(
    () =>
      autorun(() => {
        setState(getProps(store));
      }),
    [store], // we need this to track of store filter change in single select
  );

  return state;
}
